import gql from 'graphql-tag';

const HWT_STUDENT_SETTINGS_FRAGMENT = gql`
  fragment BaseHwtStudentSettings on HwtStudentSettings {
    locale
  }
`;

export default HWT_STUDENT_SETTINGS_FRAGMENT;
